import styled from 'styled-components'

export const HistoryPopoverContentStyled = styled.div`
  min-width: ${({ theme }) => theme.typography.pxToRem(320)};
  padding: ${({ theme }) => theme.space.small};
`
